<template>
  <div class="head">
  	<div class="width1280">
  		<img src="../assets/img/logo.svg" alt="" class="logo">
  	</div> 
  </div>
</template>

<script>
export default {
  name: 'headCom', 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .head{
 	height: 64px;
 	line-height: 64px;
 }
 .logo{
 	height: 30px;
 	margin:17px 0 0 80px;
 }
 @media screen and (max-width:600px){  
   .head{
   	height: 1.706667rem;
   	line-height: 1.706667rem;
   }
   .logo{
	 	height: 0.853333rem;
	 	margin-left: 0.533333rem;
	 	vertical-align: middle;
    margin-top: 0;
	 }
 }
</style>
